import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

export default function MessageModal({
    show,
    onHide,
    onConfirm,
    title = "Confirmação",
    message = "Deseja realizar esta ação?",
    confirmText = "Confirmar",
    confirmVariant = "primary", // Pode ser 'danger', 'warning', 'success', etc.
    icon = faQuestionCircle,
    isLoading = false,
    id = 0
}) {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton className={`bg-${confirmVariant} text-white`}>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center py-4">
                <div>{message}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onHide} disabled={isLoading}>
                    <FontAwesomeIcon icon={faClose} /> Ok
                </Button>
            </Modal.Footer>
        </Modal>
    );
}